import React, { useLayoutEffect } from "react";
import { useTemplateSetting } from "../../../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../../../constant/common";
import i18n from "../../../locale/i18n";
import QuadrataAverageBasedCalculator from "./templates/QuadrataAverageBasedCalculator";
import VictorAverageBasedCalculator from "./templates/VictorAverageBasedCalculator";
import Icon from "../../../components/ui/Icon";
import { useDispatch } from "react-redux";
import { setSelectedInstrument } from "../../../store/slice/trade";

const searchParams = new URLSearchParams(window.location.search);
const searchString = searchParams.toString();

const baseUrl = window.location.origin + window.appSettings.toolUrlBase;

window.euroland?.createComponent("AverageBasedCalculatorModal", {
  tag: "average-based-calculator-modal",
  url: baseUrl + 'average-based-calculator' + (searchString.length ? `?${searchString}` : ""),
  dimensions: {
    width: "960px",
    height: "90vh",
  },
  autoResize: {
    height: true,
    element: "#root",
  },
  template: {
    name: 'modal',
    clickOverlayToClose: false,
    styles: {
      position: 'fixed',
      bottom: '0px'
    }
  },
  props: {
    selectedInstrument: {
      type: "object",
      required: true,
    }
  },
});

window.addEventListener("error", (e) => {
  if (e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    return false;
  }
});

const EurolandAverageBasedCalculatorModal = () => {
  const template = useTemplateSetting();
  const dispatch = useDispatch();

  const handleClose = () => {
    window.xprops?.close();
  };

  const renderTemplate = () => {
    switch (template) {
      case TOOL_TEMPLATE.quadrata:
        return <QuadrataAverageBasedCalculator onClose={handleClose} />;
      case TOOL_TEMPLATE.victor:
        return <VictorAverageBasedCalculator onClose={handleClose} />;
      default:
        return null;
    }
  };

  if (!document.body.classList.contains('average-based-calculator-modal-body')) {
    document.body.classList.add('average-based-calculator-modal-body');
  }

  useLayoutEffect(() => {
    document.body.setAttribute("dir", window.appSettings?.isRtl ? "rtl" : "ltr");
    return () => {
      document.body.removeAttribute("dir");
    };
  }, []);

  useLayoutEffect(() => {
    if (window.xprops?.selectedInstrument) {
      dispatch(setSelectedInstrument(window.xprops.selectedInstrument.instrumentId));
    }
  }, [dispatch]);

  const templateSuffix = template === TOOL_TEMPLATE.quadrata ? 'template-quadrata' : template === TOOL_TEMPLATE.victor ? 'template-victor' : '';

  return (
    <div className={templateSuffix}>
      <div className="average-based-calculator-modal">
        <div className="average-based-calculator-modal__header">
          <h2 className="average-based-calculator-modal__title">
            {i18n.translate("averageBasedCalculator")}
          </h2>
          <button
            className="average-based-calculator-modal__close"
            onClick={handleClose}
            aria-label={i18n.translate("close")}
            type="button"
          >
            <Icon name="close" />
          </button>
        </div>
        <div className="average-based-calculator-modal__body">{renderTemplate()}</div>
      </div>
    </div>
  );
};

export default EurolandAverageBasedCalculatorModal;